import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from '.';

/**
 * Typed version of `useDispatch` hook
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();

/**
 * Typed version of `useSelector` hook
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
